class AppMessageController {
  constructor ($timeout, $log, $window) {
    'ngInject'
    this.$timeout = $timeout
    this.$log = $log
    this.$window = $window
    if (!this.delay) {
      this.delay = 5000
    } else {
      this.delay = parseInt(this.delay)
    }
  }

  $onChanges (changes) {
    // this.$log.debug('$onChanges', changes)
    const _error = changes.error
    const _success = changes.success
    if ((_error && _error.currentValue) || (_success && _success.currentValue)) {
      if (_error && _error.currentValue) this.error = _error.currentValue
      if (_success && _success.currentValue) this.success = _success.currentValue
      if (this.error && !isNaN(this.error.delay)) this.delay = this.error.delay
      else if (this.success && !isNaN(this.success.delay)) this.delay = this.success.delay
      if (this.delay > 0) {
        this.$timeout(() => {
          this.error = null
          this.success = null
        }, this.delay)
      }
    }
  }

  hide () {
    if (!this.error && !this.success && this.info) {
      this.setConsent(this.info.cookieKey)
    }
    this.error = null
    this.success = null
  }

  setConsent (cookieKey) {
    try {
      if (this.$window.localStorage) {
        this.$window.localStorage[cookieKey] = true
      }
    } catch (e) {
      this.$log.error('Error while closing info', cookieKey)
    }
  }

  getConsent (cookieKey) {
    try {
      if (this.$window.localStorage) {
        return this.$window.localStorage[cookieKey]
        ? JSON.parse(this.$window.localStorage[cookieKey])
        : false
      }
    } catch (e) {
      this.$log.error('Error while hiding info', cookieKey)
    }
  }
}

export default AppMessageController



// WEBPACK FOOTER //
// ./src/app/common/app-message/app-message.controller.js